import React from 'react';
import { CheckIcon, LockIcon, RotateCcwIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { heroBullets, heroMockup, localCurrencyNote } from '../data/content';
const trustIcons = [{
  icon: LockIcon,
  label: 'Secure payment'
}, {
  icon: ZapIcon,
  label: 'Instant access'
}, {
  icon: RotateCcwIcon,
  label: '7-day guarantee'
}];
export function Hero() {
  return <header className="relative overflow-hidden border-b border-navy-700 bg-navy" data-id="element-124" data-mp="12a0it4iflorg">
      <div className="grain absolute inset-0" aria-hidden="true" data-id="element-125" data-mp="xanpq20yvlgf" />
      <div className="pointer-events-none absolute left-1/2 top-0 h-[420px] w-[620px] -translate-x-1/2 rounded-full bg-navy-600/25 blur-[120px] lg:h-[560px] lg:w-[820px]" aria-hidden="true" data-id="element-126" data-mp="x8b85pz4fd3w" />
      <div className="relative mx-auto max-w-page px-4 py-10 text-center sm:px-5 sm:py-14 lg:py-20" data-id="element-127" data-mp="nekkuoeqd8ps">
        <p className="font-display text-[10px] font-bold uppercase tracking-[0.22em] text-gold sm:text-xs sm:tracking-[0.26em]" data-id="element-128" data-mp="382fern45x2ee">
          The Blues Teacher’s Arsenal™
        </p>

        <h1 className="mx-auto mt-5 max-w-4xl font-display text-[1.85rem] font-extrabold leading-[1.08] tracking-[-0.03em] text-white sm:text-[2.9rem] sm:leading-[1.04] lg:text-[3.7rem]" data-id="element-129" data-mp="3j6fxfnpbn9cs">
          Plan your entire year of blues lessons in{' '}
          <span className="text-gold" data-id="element-130" data-mp="3e8whmjcz6oiq">less than five minutes.</span>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-[15px] leading-relaxed text-mist sm:mt-6 sm:text-lg" data-id="element-131" data-mp="30iaziwvciilw">
          The definitive set of 6 volumes plus 5 strategic bonuses. 300+ ready-to-teach sessions,
          120+ visual reference cards, and every tool you need to track student growth — already
          prepared for you.
        </p>

        <div className="mx-auto mt-8 max-w-4xl sm:mt-10" data-id="element-132" data-mp="2vjpxqt0g3qvc">
          <img src={heroMockup} alt="The complete system: six blues teaching workbooks with the desktop, tablet and phone editions, plus the five exclusive bonuses" className="w-full" width={1671} height={933} data-id="element-133" data-mp="2hjf79r31seap" />
        </div>

        <ul className="mx-auto mt-8 grid max-w-md grid-cols-1 gap-2.5 text-left sm:mt-10 sm:flex sm:max-w-none sm:flex-wrap sm:justify-center sm:gap-x-6 sm:gap-y-3 sm:text-center" data-id="element-134" data-mp="nbba6qtxtx1l">
          {heroBullets.map(bullet => <li key={bullet} className="flex items-center gap-2" data-id="element-135" data-mp="ddwxn2b4xsek">
              <CheckIcon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" strokeWidth={3} data-id="element-136" data-mp="1b0vvvhhh78ek" />
              <span className="font-display text-[11px] font-bold uppercase tracking-[0.1em] text-white" data-id="element-137" data-mp="161t1qs31amld">
                {bullet}
              </span>
            </li>)}
        </ul>

        <div className="mx-auto mt-8 max-w-sm sm:mt-10 sm:max-w-md" data-id="element-138" data-mp="114kg2hiog0fd">
          <CtaButton label="Get the system now" size="lg" fullWidth data-id="element-139" data-mp="x0uwk6gv0917" />
        </div>

        <p className="mt-3 text-[13px] text-mist" data-id="element-140" data-mp="3ltqc7blwotsz">{localCurrencyNote}</p>

        <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 sm:mt-6 sm:gap-x-6" data-id="element-141" data-mp="3hr3tc077qj7x">
          {trustIcons.map(({
          icon: Icon,
          label
        }) => <li key={label} className="flex items-center gap-2 text-[11px] text-steel sm:text-xs" data-id="element-142" data-mp="1x7hvhcqqi10c">
              <Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-143" data-mp="218jzs7zid396" />
              {label}
            </li>)}
        </ul>
      </div>
    </header>;
}